import React from 'react';

import Framework from "@beardeddevops/react.framework";
import UserRoles from "constants/UserRoles";
import CustomerQuickEdit from 'components/Containers/CustomerQuickEdit';
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class Dispatch extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {
		let {
			history,
			reloadShell,
			baseUrl,
			roles,
		} = this.props;
		
		return (
			<div className="container-fluid">
				<CustomerQuickEdit
					history={history}
					baseUrl={baseUrl}
					reloadShell={reloadShell}
					roles={roles}
				/>
			</div>
		);
	}
}


